// Define a class for a bullet
// I will later refactor this code to add different weapons

import {Vector} from "./i.js"; // ./vector.js
import {ConfigStructure, EitherOr, RequiredProperty} from "./i.js"; // ./validators.js
import {Particles} from "./i.js"; // ./particles.js
import {StraightLineAI} from "./i.js"; // ./ai.js
import {Thing, THING_TYPES, Z_INDICES} from "./i.js"; // ./thing.js

// TODO: This specific weapon should be called blaster, not bullet
export class Bullet extends Thing {
	static CONFIG_STRUCTURE = new ConfigStructure([
		// pos of this bullet, a vector with values in flares
		new RequiredProperty("pos", v => (v instanceof Vector)),
		// rot of this bullet, in radians
		new RequiredProperty("rot", v => (Number.isFinite(v))),
		new EitherOr([
			// vel of the thing firing the bullet, a vector in flares / second
			new RequiredProperty("parentVel", v => (v instanceof Vector))
		], [
			// vel of this bullet, a vector with values in flares / second
			new RequiredProperty("vel", v => (v instanceof Vector)),
			// Health of this bullet
			new RequiredProperty("health", v => (Number.isFinite(v) && v >= 0))
		])
	]);

	static SPEED = 4;  // flares / second


	// Create a bullet
	// config is an object with the properties provided by the spawn request
	// enrichment, plus the properties specified in CONFIG_STRUCTURE above.
	constructor(config) {
		Bullet.CONFIG_STRUCTURE.test(config);

		config.texture = "images/blaster.svg";
		config.zIndex  = Z_INDICES.PLAYER_CHILD;
		config.len     = 0.1;
		config.type    = THING_TYPES.BULLET;
		config.canDespawn = true;
		config.despawnSafetyWindow = 0;
		if (config.vel === undefined) {
			// If vel is undefined, then parentVel must be defined
			config.vel = new Vector(Bullet.SPEED, 0)
				.rotateBy(config.rot)
				.add(config.parentVel);
		}
		config.maxHealth = config.space.game.unicenter.upgrader
			.getValue("DAMAGE");
		super(config);
		this.ai = new StraightLineAI(this, {});
	}

	// Take damage from an attack
	// damage is a number.
	takeDamage(damage) {
		// The bullet is not piercing
		this.prepareToDie(false);
	}

	// Save this bullet into a config object
	// See the comment on Thing.save() for more details.
	save() {
		let config = super.save().config;
		return {
			config:     config,
			isComplete: true
		};
	}

	// Prepare this bullet for removal
	// See the comment on Thing.prepareToDie() for more details.
	// dropParticles is a boolean that defaults to true.
	// TODO: Make the dropParticles argument consistent across all things.
	prepareToDie(dropItems, dropParticles) {
		if (dropParticles !== false) {
			this.space.particles.add(
				Particles.TYPES.BLASTER,
				// Fire particles from the front tip of the bullet
				Vector.sum(
					this.pos,
					new Vector(this.len / 2, 0).rotateBy(this.rot)
				),
				// Don't preserve the bullet's momentum because I want to create
				// an impression that the bullet lost its momentum upon hitting
				// the target
				null,
				5
			);
		}

		super.prepareToDie(dropItems);
	}
}
